import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  checkAccess,
  confirmDelete,
  ErrorMsg,
  InfoIcon,
  sessionUser,
  ValidateForm,
} from "../../Util/common";
import { KendoGrid } from "../../Kendo/kendo_grid";
import {
  CorebaseURL,
  corefetch,
  corepost,
  ImageURL,
} from "../../Util/axios_core_helper";
import { KendoDropdown } from "../../Kendo/kendo_dropdown";
import { KendoLoader } from "../../Kendo/kendo_loader";

export const Videos = () => {
  const [VideoList, setVideoList] = useState({
    ID: 0,
    DisplayedInID: "",
    Video: "",
    OldVideoPath: "",
  });
  const [refreshflag, setrefreshflag] = useState(0);
  const [DisplayedInList, setDisplayedInList] = useState([]);

  const [editVisible, setEditVisible] = useState(false);
  const [error, setError] = useState({});
  const modalRef = useRef(null);
  const [Loading, setLoading] = useState(false);

  const clearForm = () => {
    $("#hide").click();
    setLoading(false);
    setVideoList({
      ID: 0,
      DisplayedInID: "",
      Video: "",
      OldVideoPath: "",
    });
    setError({});

    setEditVisible(false);
    const form = document.getElementById("form-culture-config");
    if (form) {
      form.reset();
    }
    $(".modal-backdrop.show").hide();
  };
  const onSubmit = async (e) => {
    e.preventDefault();
    const maxSizeInMB = 20;
    const maxSizeInBytes = maxSizeInMB * 1024 * 1024;
    let oversize = false;
    oversize = VideoList.Video?.size > maxSizeInBytes;

    var err = ValidateForm(e);
    if (err) {
      setError(err);
      setError(err);
      setError((prevError) => ({
        ...prevError,
        InValidFileSize: oversize,
      }));
    } else if (!oversize) {
      setLoading(true);
      setError((prevError) => ({
        ...prevError,
        InValidFileSize: false,
      }));
      const formData = new FormData();
      formData.append("VideosID", VideoList.ID);
      formData.append("DisplayedInID", VideoList.DisplayedInID);
      formData.append("OldVideoPath", VideoList.OldVideoPath);
      formData.append("SavedBy", sessionUser());
      if (VideoList.Video) {
        formData.append("VideoFile", VideoList.Video);
      }

      await corepost("Videos/InsertUpdateVideos", formData);
      clearForm();
      $("#videos-cancel").click();

      setrefreshflag(refreshflag + 1);
    } else {
      setError((prevError) => ({
        ...prevError,
        InValidFileSize: true,
      }));
    }
  };
  const handleEditClick = async (e) => {
    let data = await corefetch(
      `Videos/GetDisplayesInList?id=${e.displayedInID}`
    );
    setDisplayedInList(data);
    let temp = VideoList;

    VideoList.ID = e.videosID;
    VideoList.DisplayedInID = e.displayedInID;
    VideoList.Video = e.videopath;
    VideoList.OldVideoPath = e.videopath;

    setVideoList(temp);

    setEditVisible(true);
    const modal = new bootstrap.Modal(document.getElementById("add_Videos"));
    modal.show();
  };
  const handleAddClick = async (e) => {
    clearForm();
    let data = await corefetch("Videos/GetDisplayesInList");
    setDisplayedInList(data);

    const modal = new bootstrap.Modal(document.getElementById("add_Videos"));
    modal.show();
  };

  const handleDeleteClick = async (e) => {
    const onDelete = () => {
      corefetch(
        `Videos/DeleteVideos?videosId=${e.videosID}`,
        true,
        false,
        true
      ).then(() => {
        setrefreshflag((prev) => prev + 1);
      });
    };
    confirmDelete(onDelete);
  };

  const onValidation = (name, val) => {
    setError((prvErr) => {
      return {
        ...prvErr,
        [name]:
          !val || (val && val.trim() == "") || (val && val.trim().length == 0),
      };
    });
  };
  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (!file) {
      setError((prevError) => ({
        ...prevError,
        ValidFile: false,
        InValidFileSize: false,
      }));
      setVideoList((prev) => ({
        ...prev,
        Video: "",
      }));
      onValidation("Video", e.target.value);
      return;
    }

    if (file && file.type.startsWith("video/")) {
      setError({ ...error, ValidFile: false });

      const maxSizeInMB = 20;
      const maxSizeInBytes = maxSizeInMB * 1024 * 1024;

      const isFileTooLarge = file.size > maxSizeInBytes;

      setError((prevError) => ({
        ...prevError,
        ValidFile: false,
        InValidFileSize: isFileTooLarge,
      }));

      if (isFileTooLarge) {
        // If the file size exceeds the allowed limit
        setVideoList((prev) => ({
          ...prev,
          Video: file,
        }));
      } else {
        // Valid video file
        let temp = VideoList;
        temp.Video = file;
        setVideoList(temp);

        document.getElementById("video-name").value = file.name; // Display file name
      }

      onValidation("Video", e.target.value);
    } else {
      // e.target.value = "";
      setError((prevError) => ({
        ...prevError,
        ValidFile: true,
        InValidFileSize: false,
      }));
      setVideoList((prev) => ({
        ...prev,
        Video: "",
      }));
    }
  };

  return (
    <>
      <div className="page-header">
        <div className="row">
          <div className="col-sm-12">
            <h3 className="page-title">Videos</h3>
            <ul className="breadcrumb">
              <li className="breadcrumb-item">
                <li>Configuration</li>
              </li>
              <li className="breadcrumb-item active">Videos</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="card bg-white">
        <div className="card-body">
          <div className="col-auto ms-auto">
            <div className="row">
              <div className="col-sm-6"></div>
              <div className="col-auto float-end ms-auto">
                <div className="d-flex justify-content-end mb-2">
                  <Button
                    name={"Add"}
                    dataBsToggle={"modal"}
                    dataBsTarget={"#add_Videos"}
                    dataBsDismiss={"modal"}
                    onClick={handleAddClick}
                  />
                </div>
              </div>
            </div>

            <div>
              <KendoGrid
                name={"welcomeTo-config"}
                url={CorebaseURL + "Videos/GetVideosDetails"}
                schema={{}}
                columns={[
                  {
                    field: "videosID",
                    filterable: false,
                    hidden: true,
                  },
                  {
                    field: "displayedInID",
                    filterable: false,
                    hidden: true,
                  },
                  {
                    field: "displayedInName",
                    title: "Displayed In",
                  },
                  {
                    field: "videopath",
                    title: "File Name",
                    template: (dataItem) => {
                      const fileName = dataItem.videopath
                        ? dataItem.videopath.split(/[/\\]/).pop()
                        : "";
                      return `<span>${fileName}</span>`;
                    },
                  },
                ]}
                showOptions={true}
                showEdit={true}
                showDelete={true}
                onEditClick={handleEditClick}
                onDeleteClick={handleDeleteClick}
                disableExportExcel={true}
                refreshWhen={refreshflag}
                height={"60vh"}
              />
            </div>
          </div>
        </div>
      </div>
      {/* <!-- Add Video Modal --> */}
      <div
        className="modal custom-modal fade"
        id="add_Videos"
        ref={modalRef}
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                {editVisible ? "Edit Video" : "Add Video"}
              </h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  clearForm();
                }}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form id="form-culture-config" onSubmit={onSubmit}>
                <div className="row">
                  <div className="col-md-12 mb-3">
                    <label className="form-label">
                      Displayed In <span className="text-danger">*</span>
                    </label>
                    <KendoDropdown
                      name="DisplayedInID"
                      data={DisplayedInList}
                      // url={CorebaseURL + "Videos/GetDisplayesInList"}
                      value={VideoList.DisplayedInID}
                      dataTextField="eventName"
                      dataValueField="displayedInID"
                      placeholder="Select Displayed In..."
                      required={true}
                      onChange={(e) => {
                        onValidation("DisplayedInID", e);

                        setVideoList((prevVideos) => ({
                          ...prevVideos,
                          DisplayedInID: e,
                        }));
                      }}
                    />
                    {error.DisplayedInID && (
                      <ErrorMsg text="Displayed In is required" />
                    )}
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-12">
                    <label className="form-label">
                      Upload Video <span className="text-danger">*</span>
                      <InfoIcon content="Kindly ensure the file size is below 20MB for upload." />
                    </label>
                    <input
                      className="form-control"
                      type="file"
                      name="file"
                      accept="Video/*"
                      onChange={handleFileChange}
                    />

                    {error.Video && <ErrorMsg text="Video is required" />}
                    {error.ValidFile && (
                      <ErrorMsg text="please upload Video file only" />
                    )}
                    {error.InValidFileSize && (
                      <ErrorMsg text="File size exceeds 20MB. Please upload a smaller file." />
                    )}
                  </div>
                  <div className="row mt-1 mb-3">
                    {VideoList.OldVideoPath && VideoList.ID > 0 && (
                      <div
                        style={{
                          width: "100%",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        <a
                          href={`${ImageURL}${VideoList.OldVideoPath}`}
                          target="_blank"
                          style={{
                            textDecoration: "underline",
                            fontSize: "13px",
                          }}
                        >
                          {VideoList.OldVideoPath.split("/").pop()}
                        </a>
                      </div>
                    )}
                    <input
                      type="hidden"
                      name="Video"
                      id="video-name"
                      data-required="true"
                      value={VideoList.Video || ""}
                    />
                    <input
                      type="hidden"
                      name="OldimagePath"
                      value={VideoList.OldVideoPath}
                    />
                  </div>
                </div>
                {Loading ? (
                  <KendoLoader className="d-flex justify-content-end align-items-center" />
                ) : (
                  <div className="text-end">
                    <Button
                      name={"Cancel"}
                      isCancelButton={true}
                      id="videos-cancel"
                      dataBsDismiss={"modal"}
                      onClick={() => {
                        clearForm();
                      }}
                    />
                    {/* <Button name={"Save"} /> */}
                    <Button name={editVisible ? "Update" : "Save"} />
                  </div>
                )}
                <button
                  type="button"
                  id="hide"
                  style={{ display: "none" }}
                  data-bs-dismiss={"modal"}
                  onClick={() => {
                    clearForm();
                  }}
                ></button>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- /Add Video Modal --> */}
    </>
  );
};
